module.exports = __webpack_public_path__ + "static/bookfhr-db2c5c8587e9ac4a7a492d227df44c6b.jpg";